import {useEffect, useState} from "react";
import {findActiveBookingsWithPagination} from "../api/apiClient";

export const useActiveBookings = (page, reloadTrigger) => {
    const [activeBookings, setActiveBookings] = useState([]);
    const [activeBookingsPagination, setActiveBookingsPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const activeBookingsWithPagination = findActiveBookingsWithPagination(page, abortController.signal);

        activeBookingsWithPagination
            .then(
                (data) => {
                    const bookings = data.bookings;
                    const pagination = data.pagination;

                    setActiveBookings(bookings)
                    setActiveBookingsPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, reloadTrigger]);

    return {activeBookings : activeBookings, activeBookingsPagination : activeBookingsPagination};
};